<span *ngIf="isAdminMark === true; else user">{{ getAdminDisplay() }}</span>
<ng-template #user>
  <span>{{ getUserDisplay() }}</span>
</ng-template>